import { useContext } from 'react';
import { InboundContext } from '../context/InboundContext';
import { TopHeader, MessageCard } from '../components/common';
import PoweredbySaral from '../assets/images/powered-by-saral.svg';
import styles from '../styles/success.module.css';

export default function AlreadySubmitted() {
  const { inboundData, t } = useContext(InboundContext);

  const getBrandWebsiteURL = (link: string | undefined) => {
    if (!link?.includes('http')) return `https://${link}`;
    return link;
  };

  return (
    <div className={styles.successContainer}>
      <TopHeader />
      <div className={styles.successCardContainer}>
        <MessageCard
          width={330}
          // image={SuccessCardImage}
          heading={t('applicationAlreadySubmittedHeader')}
          message={t('applicationAlreadySubmittedSubTitle')}
          buttonText={t('goBackToStoreCta')}
          onClick={() => {
            window.location.href = getBrandWebsiteURL(inboundData?.landingPage?.brandWebsite);
          }}
          buttonColor={inboundData?.thanksPage.colors.btn}
          buttonTextColor={inboundData?.thanksPage.colors.btnText}
          titleColor={inboundData?.landingPage.colors.headline}
          textColor={inboundData?.landingPage.colors.subText}
        />
      </div>
      <a href="https://getsaral.com" target="_blank" rel="noreferrer">
        <img src={PoweredbySaral} alt="powered by Saral" className={styles.poweredBySaral} />
      </a>
    </div>
  );
}
